import React from "react";
import { Spinner } from "flowbite-react";

export default function PageLoader({ label = "Loading..." }) {
  return (
    <div className="flex min-h-[320px] flex-col items-center justify-center gap-3">
      <Spinner
        style={{ color: "#0078e7" }}
        aria-label={label}
        size="xl"
      />
      <span className="text-sm text-gray-500 dark:text-gray-400">{label}</span>
    </div>
  );
}
